import { PUBLISHED } from '../constants';

const UNDERSCORE = '_';

const getUnpublishedEntityName = entity =>
  entity
    .split(UNDERSCORE)
    .filter(word => word !== PUBLISHED)
    .join(UNDERSCORE);

export default getUnpublishedEntityName;
